import { render, staticRenderFns } from "./FormVehicle.vue?vue&type=template&id=00ff4a08"
import script from "./FormVehicle.vue?vue&type=script&lang=js"
export * from "./FormVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormVehicle.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ff4a08')) {
      api.createRecord('00ff4a08', component.options)
    } else {
      api.reload('00ff4a08', component.options)
    }
    module.hot.accept("./FormVehicle.vue?vue&type=template&id=00ff4a08", function () {
      api.rerender('00ff4a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fleet/src/components/FormVehicle.vue"
export default component.exports